<script lang="ts" setup>
import BaseCard from '@/core/components/base/BaseCard.vue';
import formatHelper from '@/core/helpers/formatHelper';
import BaseCardBody from '@/core/components/base/BaseCardBody.vue';
import {FlowchartInstance} from "@/core/interfaces/flowchart/flowchart";
import {Network} from "@lucide/vue";
import FlowchartInstanceCardPopoverMenu from "@/flowcharts/Components/FlowchartInstanceCardPopoverMenu.vue";

defineProps<{
    instance: FlowchartInstance;
}>();

const emit = defineEmits<{ (event: 'deleted'): void }>();

</script>

<template>
  <div class="min-w-0">
    <div class="text-sm">
      {{ formatHelper.readableDate(instance.created_at) }}
    </div>
    <base-card class="flex flex-1">
      <base-card-body class="w-full min-w-0">
        <div class="flex items-center justify-between">
          <Network class="text-primary mr-5 shrink-0" />
          <div class="flex-1 min-w-0">
            <strong class="block truncate" :title="instance.flowchart.name">{{ instance.flowchart.name }}</strong>
            <div class="flex flex-row items-start">
              <img
                alt="Verdict"
                src="@/assets/images/verdict-chevrons.png"
                class="mr-3 w-8 shrink-0 object-contain"
              >
              <p class="text-sm truncate min-w-0" :title="instance.verdict?.label">
                {{ instance.verdict?.label }}
              </p>
            </div>
          </div>
          <div class="w-8 shrink-0">
            <FlowchartInstanceCardPopoverMenu :instance="instance" @deleted="emit('deleted')" />
          </div>
        </div>
      </base-card-body>
    </base-card>
  </div>
</template>
